import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll,  } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks";

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()

    const [showScrollButton, setShowScrollButton] = useState(false);

    // Detectar el scroll para mostrar/ocultar el botón
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Función para volver arriba
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"
    return (

        <>
            {foundProducts ? (
                <div
                    class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-mb-0 pd-my-n-2 ns-mx-auto"
                    data-nosto-element="search"
                >
                    {(foundProducts || (loading && foundProducts)) && <Sidebar toggleId={toggleButtonId} />}
                    <div
                        class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5 pd-products-container"
                        style={loading ? "position: relative;" : ""}
                    >
                        {/* <SelectedFilters /> */}
                        <Toolbar lableFor={toggleButtonId} />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                        {/* <BottomToolbar /> */}

                    </div>
                </div>
            ) : loading ? (
                // <Loader />
                <></>
            ) : (
                <NoResults />
            )}

            {showScrollButton && (
                <button
                    onClick={scrollToTop}
                    class="scroll-to-top"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" id="Chevron-Up-Circle-Outline--Streamline-Ionic-Outline" height="48" width="48"><desc>Chevron Up Circle Outline Streamline Icon: https://streamlinehq.com</desc><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M34.8557 28.5227 24.0004 17.6673 13.1449 28.5227" stroke-width="3"></path></svg>
                </button>
            )}

            {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
            {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
        </>


    )
}
